type Row = Record<string, unknown>;

export function isAdminArchivedRow(r: Row): boolean {
  const v = r.deleted_at;
  if (v == null) return false;
  return String(v).trim().length > 0;
}

/** `/admin/events/:mode` の mode（該当パスでないときは undefined） */
export function adminEventsListModeFromPathname(pathname: string): string | undefined {
  const m = pathname.match(/^\/admin\/events\/([^/]+)$/);
  return m?.[1];
}

/** 予定管理タブ／カレンダー：mode ごとの行フィルタ。`all` と未指定はアーカイブ以外すべて */
export function adminRowMatchesEventsListMode(r: Row, mode: string | undefined): boolean {
  if (!mode || mode === "all") return !isAdminArchivedRow(r);
  if (mode !== "archive" && isAdminArchivedRow(r)) return false;
  if (mode === "karin") return Boolean(r.is_karin);
  if (mode === "helloproject") return r.source === "helloproject" || (r.source === "fan_post" && Boolean(String(r.fan_group_name ?? "").trim()));
  if (mode === "jp_room") {
    if (r.source === "jp_room" || r.source === "mline") return true;
    return r.source === "fan_post" && Boolean(String(r.fan_artist_name ?? "").trim()) && !String(r.fan_group_name ?? "").trim();
  }
  if (mode === "mline") return r.source === "mline";
  if (mode === "pending") return r.status === "pending_review";
  if (mode === "archive") return isAdminArchivedRow(r);
  return true;
}

export function adminEventsListModeTitle(mode: string | undefined): string {
  if (mode === "all") return "全ての予定";
  if (mode === "karin") return "宮本佳林予定管理";
  if (mode === "helloproject") return "ハロプロ予定管理";
  if (mode === "jp_room") return "M-line J.P ROOM 予定管理";
  if (mode === "mline") return "M-line 予定管理";
  if (mode === "pending") return "確認待ち一覧";
  if (mode === "archive") return "アーカイブ一覧";
  return "予定管理";
}
